import {
  PROVIDER_DETAIL_TABS,
  ServiceProvider,
  StageKey,
  STATUS_TYPES,
  StatusKey,
} from "../../../utils/integrationConfigData";

interface ProviderDetailTabsProps {
  activeTab: string;
  onChange: (tabId: string) => void;
  provider?: ServiceProvider | null;
  showCptTab?: boolean;
}

const resolveStatusKey = (status: string): StatusKey =>
  (status as StatusKey) in STATUS_TYPES ? (status as StatusKey) : "notSet";

const ProviderDetailTabs = ({
  activeTab,
  onChange,
  provider,
  showCptTab = true,
}: ProviderDetailTabsProps) => {
  const tabs = showCptTab
    ? PROVIDER_DETAIL_TABS
    : PROVIDER_DETAIL_TABS.filter((tab) => tab.id !== "cpt");

  return (
    <div className="ic-detail-tabs" role="tablist" aria-label="Provider details">
      {tabs.map((tab) => {
        const stageKey = tab.stage as StageKey | undefined;
        const showDot = Boolean(stageKey);
        const statusKey =
          showDot && stageKey && provider
            ? resolveStatusKey(provider[stageKey])
            : "notSet";
        const tone = STATUS_TYPES[statusKey].tone;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`ic-detail-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {showDot && stageKey && (
              <span
                className={`ic-stage-dot ic-stage-dot--${tone} ic-stage-dot--${statusKey}`}
                aria-hidden="true"
              />
            )}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ProviderDetailTabs;

